import React, { useContext } from 'react';
import clsx from 'clsx';
import { Link } from 'react-router-dom';

import { HistoryContext } from 'components/contexts';

import { Button } from '../Button/Button';
import { Icon } from '../Icon/Icon';

import styles from './BackButton.module.scss';

export type BackButtonProps = {
  back?: string;
  className?: string;
  onBackClick?: () => void
};

export const BackButton: React.FC<BackButtonProps> = ({ back, className, onBackClick }) => {
  const { removeLastTwoLinks, backLink } = useContext(HistoryContext);
  const backTo = back || backLink || '/';
  const goBackClick = (e: any) => {
    e.preventDefault()
    onBackClick && onBackClick()
  } 

  return (
    <Link className={clsx(styles.root, className)} to={backTo} onClick={onBackClick ? goBackClick : removeLastTwoLinks}>
      <Button className={styles.button} type="bordered">
        <Icon name="arrow-left" className={styles.icon} />
        Back
      </Button>
    </Link>
  );
};
